import { BannerProps } from "../../components/banner";
import { BannerInline } from "../../components/banner-inline";

const test = ({ layout }: { layout: string }): boolean =>
  layout === "Inline Banner";

const create = (props: { banner: BannerProps }): JSX.Element => {
  return <BannerInline {...props.banner} />;
};

export default { test, create };
